export default __webpack_public_path__ + "static/media/graphic-08.6cc900ac.png";